import { recaptchaUpdater } from '../../modules/recaptcha';
import passRules from '../../modules/passRules';

const $form = document.querySelector('.form-signin');

export const profilesPassword = () => {
  passRules.init();
  recaptchaUpdater('profile');

  $form.length &&
    $form.addEventListener('submit', function (e) {
      if (!passRules.settings.submit) {
        e.preventDefault();
      }
    });
};
